/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const PersonCircleArrowIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 24 24"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="M15.5,18.5 L21.5,18.5 L15.5,18.5 Z" />
      <polyline points="19.5 16.5 21.5 18.5 19.5 20.5 19.5 20.5" />
      <path d="M13.5,18.5 C13.5,15.7385763 15.7385763,13.5 18.5,13.5 C21.2614237,13.5 23.5,15.7385763 23.5,18.5 C23.5,21.2614237 21.2614237,23.5 18.5,23.5 C15.7385763,23.5 13.5,21.2614237 13.5,18.5 Z" />
      <path d="M12.5,14.5 L12.5,11.696" />
      <path d="M7.5,11.696 L7.5,14.5 L2.491,16.289 C1.297,16.716 0.5,17.847 0.5,19.114 L0.5,21.5 L11.5,21.5" />
      <ellipse cx="10" cy="6.5" rx="5" ry="6" />
      <path d="M14.953,5.953 C14.785,5.974 14.669,5.967 14.5,6 C12.797,6.328 11.703,5.711 10.766,4.07 C10.203,5.148 8.444,6 7,6 C6.289,6 5.677,5.854 5.064,5.534" />
    </g>
  </svg>
);

export default PersonCircleArrowIcon;
